export enum TaskInfluence {
  PLUS = 1,
  MINUS = 2,
  NO_CHANGES = 3,
  NO_ESTIMATION = 4
}
